export default __webpack_public_path__ + "static/algarLogo-b43cbff60efa93b2a891899dd65e17db.png";